import * as React from 'react';
import { ArrowForward } from '../../../Icons';
import { useTheme } from '../../../theme';
import cn from 'classnames';
import FullscreenDialogClose from '../Close/Close';
import { Props as BaseProps } from '../FullscreenDialog';
import { useRenderers } from '../../../renderProps';

type Props = Pick<BaseProps, 'onClose' | 'closeClassName' | 'headerClassName' | 'title'> & {
	renderBeforeCloseButton?: () => React.ReactElement;
	hideTitle?: boolean;
};

const FullScreenDialogHeader: React.FC<Props> = ({
	onClose,
	closeClassName,
	headerClassName,
	title,
	renderBeforeCloseButton,
	hideTitle
}) => {
	const { FullscreenDialog: theme } = useTheme('FullscreenDialog');

	const { renderFullScreenDialogClose } = useRenderers();

	const renderCloseButton = React.useMemo(() => {
		if (renderFullScreenDialogClose) {
			return renderFullScreenDialogClose({
				onClose,
				closeClassName
			});
		} else {
			return <FullscreenDialogClose onClose={onClose} closeClassName={closeClassName} />;
		}
	}, [onClose, closeClassName, renderFullScreenDialogClose]);

	return (
		<div className={cn(theme.header, headerClassName)}>
			<div className={theme.header__wrapper}>
				{!hideTitle && (
					<div className={theme.header__title}>
						<div className={theme.back} onClick={onClose}>
							{ArrowForward}
						</div>

						{title}
					</div>
				)}

				{renderBeforeCloseButton?.()}

				{renderCloseButton}
			</div>
		</div>
	);
};

export default FullScreenDialogHeader;
